import * as CodeMirror from 'codemirror';
import { throttle } from "lodash-es";
import * as S from "./uicore-css-color-widget.module.css";
import 'codemirror/mode/css/css';
import { delay } from "../../../../lib/utils";
import { getChromeColorPopover } from "../../../../lib/comps/ExprInput/addon/ChromeColorPopover";
const cssLangMeta = CodeMirror.mimeModes['text/css'];
const colorKeys = cssLangMeta.colorKeywords;
const isColorLiteral = str => {
  if (colorKeys[str]) return true;
  const m = /^#[0-9a-f]+$/i.exec(str);
  if (m && [3, 4, 6, 8].includes(m[0].length - 1)) return true;
  return false;
};
export function installCodeMirrorColorWidget(cm, forceFlush) {
  const widgets = [];
  const isColorToken = token => /\b(keyword|atom)\b/.test(token.type) && isColorLiteral(token.string);
  let lastPopoverLine = -1;
  /** 一个小按钮 展示当前token的颜色 并且在点击时弹出一个color-popover并直接将修改写入cm对应的token位置上 */
  const prepareColorPopoverElement = (line, token) => {
    // 选择了createElement 用vue把节点都渲染出来再用el弄进来也行 但是用这个可以只依赖cm内部的状态 不用管外面的styleobject兼容性更好
    const element = document.createElement('span');
    element.setAttribute('class', S.colorBlockSpan);
    element.setAttribute('style', `--uccw-color: ${token.string};`);
    element.addEventListener('click', ev => {
      const popover = getChromeColorPopover();
      if (popover.colorPickerVisible && lastPopoverLine === line) {
        popover.closeColorPopover();
        lastPopoverLine = line;
        return;
      }
      lastPopoverLine = line;
      const cmElement = ev.target.closest('.CodeMirror-code');
      const posX = cmElement.getBoundingClientRect().x;
      popover.openColorPopover(token.string, {
        x: posX,
        y: ev.y
      }, newString => {
        const tokens = cm.getLineTokens(line);
        // 颜色选择器输出的是hexargb 如果之前颜色的长度不一样的话替换的时候要重新寻找替换长度
        const cssToken = tokens.find(tokenNew => tokenNew.start === token.start && isColorToken(tokenNew));
        if (!cssToken) return;
        const posStart = CodeMirror.Pos(line, cssToken.start);
        const posEnd = CodeMirror.Pos(line, cssToken.end);
        cm.replaceRange(newString, posStart, posEnd);
        forceFlush();
      });
    });
    return element;
  };
  const updateWidgets = throttle(async () => {
    // 有时候刷新之后viewport会返回from: 0,to:0 所以要延迟
    await delay(1);
    cm.operation(() => {
      const viewport = cm.getViewport();
      if (viewport.from === 0 && viewport.to === 0) {
        // 刚刷新完还没刷出来行 不做处理
        return;
      }
      widgets.forEach(w => w.clear());
      widgets.length = 0;
      // [from,to)
      for (let line = viewport.from; line < viewport.to; line += 1) {
        const tokens = cm.getLineTokens(line);
        tokens.forEach(token => {
          if (!isColorToken(token)) return;
          const pos = CodeMirror.Pos(line, token.start);
          // 如果widget.clear的时候能正确释放element 这里就不会泄露
          const widget = cm.setBookmark(pos, {
            widget: prepareColorPopoverElement(line, token)
          });
          widgets.push(widget);
        });
      }
    });
  }, 500);
  cm.on('viewportChange', updateWidgets);
  cm.on('change', updateWidgets);
  cm.on('blur', () => updateWidgets.flush());
  updateWidgets();
}
//# sourceMappingURL=uicore-css-color-widget.js.map
